module.exports = __webpack_public_path__ + "img/logo.57bd60ca.png";